import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function t(field, lang = 'en') {
  if (!field) return '';
  return field[lang] || field.en || '';
}

export default function DeleteAccount() {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('ets_lang');
    if (savedLang) setLang(savedLang);
  }, []);

  const content = {
    back: { en: '← Back to Home', zh: '← 返回首頁' },
    title: { en: 'Account Deletion Guide', zh: '刪除帳號指南' },
    subtitle: { en: 'How to delete your Every Talent Shines (ETS) account', zh: '如何刪除您的 Every Talent Shines (ETS) 帳號' },
    
    sec1Title: { en: 'In-App Account Deletion', zh: '應用程式內刪除帳號' },
    sec1P1: { 
      en: 'You can easily request to delete your account directly from within the ETS application. Follow these simple steps:', 
      zh: '您可以直接從 ETS 應用程式中輕鬆申請刪除您的帳號。請按照以下簡單步驟操作：' 
    },
    step1: { en: '1. Log into your ETS account.', zh: '1. 登入您的 ETS 帳號。' },
    step2: { en: '2. Navigate to your Profile section.', zh: '2. 導航到您的個人資料部分。' },
    step3: { en: '3. Scroll down and click on the "Delete Account" button.', zh: '3. 向下捲動並點擊「刪除帳號」按鈕。' },
    step4: { en: '4. Confirm your request in the prompt.', zh: '4. 在提示框中確認您的請求。' },
    
    sec2Title: { en: 'What Happens Next?', zh: '接下來會發生什麼？' },
    sec2P1: { 
      en: 'Once you submit the deletion request, your account will immediately become inactive. You will be logged out of the app and will no longer be able to access your data.', 
      zh: '一旦您提交刪除請求，您的帳號將立即變為非活躍狀態。您將登出應用程式，並且無法再存取您的資料。' 
    },
    sec2P2: { 
      en: 'Our administrative team will receive your request and securely process the permanent deletion of your account and associated records within 30 days.', 
      zh: '我們的行政團隊將收到您的請求，並在 30 天內安全地處理您的帳號及相關記錄的永久刪除。' 
    },
    
    sec3Title: { en: 'Contact Us', zh: '聯絡我們' },
    sec3P1: { 
      en: 'If you have lost access to your account or prefer to request deletion via email, please contact our support team at:', 
      zh: '如果您無法存取您的帳號或希望透過電子郵件申請刪除，請聯絡我們的支援團隊：' 
    },
    email: { en: 'support@everytalentshines.com', zh: 'support@everytalentshines.com' },
  };

  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    }}>
      <Link to="/" style={{ color: '#0066cc', textDecoration: 'none', display: 'inline-block', marginBottom: '20px' }}>
        {t(content.back, lang)}
      </Link>
      
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', justifyContent: 'flex-end' }}>
        <button 
          onClick={() => { setLang('en'); localStorage.setItem('ets_lang', 'en'); }}
          style={{ 
            padding: '5px 10px', 
            background: lang === 'en' ? '#000' : '#fff',
            color: lang === 'en' ? '#fff' : '#000',
            border: '1px solid #000',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          English
        </button>
        <button 
          onClick={() => { setLang('zh'); localStorage.setItem('ets_lang', 'zh'); }}
          style={{ 
            padding: '5px 10px', 
            background: lang === 'zh' ? '#000' : '#fff',
            color: lang === 'zh' ? '#fff' : '#000',
            border: '1px solid #000',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          中文
        </button>
      </div>

      <h1 style={{ marginBottom: '10px' }}>{t(content.title, lang)}</h1>
      <p style={{ color: '#666', marginBottom: '40px' }}>{t(content.subtitle, lang)}</p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.25rem', marginBottom: '15px' }}>{t(content.sec1Title, lang)}</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>{t(content.sec1P1, lang)}</p>
        <ul style={{ lineHeight: '1.8', listStyleType: 'none', paddingLeft: '10px' }}>
          <li>{t(content.step1, lang)}</li>
          <li>{t(content.step2, lang)}</li>
          <li>{t(content.step3, lang)}</li>
          <li>{t(content.step4, lang)}</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.25rem', marginBottom: '15px' }}>{t(content.sec2Title, lang)}</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>{t(content.sec2P1, lang)}</p>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>{t(content.sec2P2, lang)}</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.25rem', marginBottom: '15px' }}>{t(content.sec3Title, lang)}</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
          {t(content.sec3P1, lang)} <br/>
          <strong><a href={`mailto:${t(content.email, lang)}`} style={{ color: '#0066cc', textDecoration: 'none' }}>{t(content.email, lang)}</a></strong>
        </p>
      </section>
    </div>
  );
}
